import * as React from "react";
import { IdIconTextPosition } from "../../../constants/IdIconTextPosition";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdTooltipAnchor } from "../../tooltip";
import { Badge } from "../badge/Badge";
import { IdBadgePosition } from "../badge/IdBadgePosition";
import { Icon } from "../icon/Icon";
import { ProgressBar } from "../progress-bar/ProgressBar";
export var IconWithProgress = function (_a) {
    var progressPercent = _a.progressPercent, icon = _a.icon, iconStyle = _a.iconStyle, iconTextComponent = _a.iconTextComponent, _b = _a.iconTextPosition, iconTextPosition = _b === void 0 ? IdIconTextPosition.Center : _b, children = _a.children, backgroundClassName = _a.backgroundClassName, fillClassName = _a.fillClassName, _c = _a.tooltipAnchor, tooltipAnchor = _c === void 0 ? IdTooltipAnchor.Bottom : _c, tooltipLoca = _a.tooltipLoca, _d = _a.tooltipVerticalAdjust, tooltipVerticalAdjust = _d === void 0 ? -IdTooltipAdjust.Small : _d;
    var iconClass = "icon-with-progress--icon";
    var iconDOM = (React.createElement(Icon, { icon: icon, styleId: iconClass + " " + iconStyle }, iconTextComponent ? iconTextComponent : undefined));
    switch (iconTextPosition) {
        case IdIconTextPosition.Under:
            iconDOM = (React.createElement("div", null,
                React.createElement(Icon, { icon: icon, styleId: iconStyle, tooltipLoca: tooltipLoca, tooltipAnchor: tooltipAnchor, tooltipVerticalAdjust: tooltipVerticalAdjust }),
                React.createElement("div", { className: iconClass + " pos-abs w100" }, iconTextComponent ? iconTextComponent : undefined)));
            break;
    }
    return (React.createElement("div", { className: "icon-with-progress" },
        React.createElement(ProgressBar, { fillClassName: fillClassName, progressPercent: progressPercent, backgroundClassName: backgroundClassName }, children),
        React.createElement(Badge, { position: IdBadgePosition.Left }, iconDOM)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon-with-progress/IconWithProgress.tsx
// module id = 183
// module chunks = 3